import React from 'react'
import Table, {
  TableBody,
  TableData,
  TableHeader,
  TableHeaderItem,
  TableRow,
} from 'components/Table'
import { useTranslation } from 'react-i18next'
import Pagination from 'components/Pagination'
import { ITEMS_PER_PAGE } from 'constant'
import { VoohMediaNode } from '../VoohCampaignForm/types'
import './VoohMediaList.scss'

type Props = {
  media: VoohMediaNode[]
  pagination?: {
    activePage: number
    setPage: (pageNumber: number) => void
    totalItemsCount: number
  }
}

const VoohMediaListTable: React.FC<Props> = ({ pagination, media }) => {
  const { t } = useTranslation()
  return (
    <>
      <Table
        tableContainerClassName={'VoohTableContainer'}
        loading={false}
      >
        <TableHeader sticky>
          <TableHeaderItem>{t('common.name')}</TableHeaderItem>
          <TableHeaderItem>{t('form.campaign.details.voohMediaNodes.city')}</TableHeaderItem>
          <TableHeaderItem>{t('form.campaign.details.voohMediaNodes.address')}</TableHeaderItem>
          <TableHeaderItem>{t('form.campaign.details.voohMediaNodes.clubAsId')}</TableHeaderItem>
        </TableHeader>

        <TableBody>
          {media.map((m: VoohMediaNode) => (
            <TableRow
              key={m.id}
              className={'MediaList__table--row'}
            >
              <TableData>{m.building?.name || ''}</TableData>
              <TableData>{m.city?.name || ''}</TableData>
              <TableData>{m.address}</TableData>
              <TableData>{m.asId}</TableData>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {pagination && (
        <Pagination
          activePage={pagination.activePage}
          itemsCountPerPage={ITEMS_PER_PAGE}
          totalItemsCount={pagination.totalItemsCount}
          onChange={pagination.setPage}
        />
      )}
    </>
  )
}

export default VoohMediaListTable
